/**
 * Variant Chooser — Customer-side variant selection modal
 * Matches admin modal style (white header, border-bottom, Cancel + Speichern)
 * Supports multi-instance selection with counters (e.g. 5x B → pick variant for each)
 */
(function () {
  'use strict';

  var API_BASE = 'https://home-5017198992.app-ionos.space';

  /* ---- state ---- */
  var _label = '';
  var _count = 0;
  var _productId = '';
  var _variants = [];      // [{number, image}]
  var _btnEl = null;        // button that opened modal
  var _selected = null;     // for single: variant number
  var _counts = {};         // for multi: { variantNumber: qty }
  var _preloaded = {};      // cache of preloaded image filenames

  function getVariantImageUrl(image) {
    if (!image) return '';
    // Kuji DB imports store full DO/CDN URLs — don't prepend local storage path
    if (/^https?:\/\//i.test(image)) return image;
    return API_BASE + '/storage/app/public/lottery_variants/' + image;
  }

  function getVariantFallbackAttr(image) {
    if (!image || /^https?:\/\//i.test(image)) return '';
    var fallback = API_BASE + '/storage/app/public/lottery_first/' + image;
    return ' onerror="this.onerror=null;this.src=\'' + fallback + '\';"';
  }

  /* ---- inject modal HTML ---- */
  var wrap = document.createElement('div');
  wrap.innerHTML =
    '<div id="vcOverlay" class="vc-overlay">' +
      '<div class="vc-modal">' +
        '<div class="vc-header">' +
          '<h3 id="vcTitle">Variante wählen</h3>' +
          '<button class="vc-close" onclick="closeVariantChooser()">&times;</button>' +
        '</div>' +
        '<div class="vc-body" id="vcBody"></div>' +
        '<div class="vc-footer">' +
          '<button class="vc-cancel-btn" onclick="closeVariantChooser()">Abbrechen</button>' +
          '<button class="vc-save-btn" id="vcSaveBtn" onclick="saveVariantChoices()" disabled>Speichern</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(wrap.firstElementChild);
  });

  /* ---- open ---- */
  window.openVariantChooser = function (label, count, productId, variants, btnEl) {
    _label = label;
    _count = count;
    _productId = productId;
    _variants = variants;
    _btnEl = btnEl;
    _selected = null;
    _counts = {};

    var title = document.getElementById('vcTitle');
    title.textContent = count > 1
      ? 'Variante wählen — ' + count + 'x ' + label
      : 'Variante wählen';

    renderBody();

    var overlay = document.getElementById('vcOverlay');
    overlay.classList.add('active');
  };

  /* ---- close ---- */
  window.closeVariantChooser = function () {
    document.getElementById('vcOverlay').classList.remove('active');
  };

  /* ---- render ---- */
  function renderBody() {
    var body = document.getElementById('vcBody');
    var html = '';

    if (_count <= 1) {
      // Single instance — show cards, click to select
      html += '<div class="vc-grid">';
      _variants.forEach(function (v) {
        var imgUrl = getVariantImageUrl(v.image);
        var sel = _selected === v.number ? ' selected' : '';
        html += '<div class="vc-card' + sel + '" data-num="' + v.number + '" onclick="vcSelectSingle(' + v.number + ')">' +
          '<img src="' + imgUrl + '" alt="Variante ' + v.number + '"' + getVariantFallbackAttr(v.image) + '>' +
          '<div class="vc-num">Variante ' + v.number + '</div>' +
        '</div>';
      });
      html += '</div>';
    } else {
      // Multi instance — show cards with +/- counters
      var total = 0;
      _variants.forEach(function (v) { total += (_counts[v.number] || 0); });
      html += '<div class="vc-counter-info">Zugewiesen: <strong>' + total + ' / ' + _count + '</strong></div>';
      html += '<div class="vc-grid">';
      _variants.forEach(function (v) {
        var imgUrl = getVariantImageUrl(v.image);
        var qty = _counts[v.number] || 0;
        var sel = qty > 0 ? ' selected' : '';
        html += '<div class="vc-card' + sel + '" data-num="' + v.number + '">' +
          '<img src="' + imgUrl + '" alt="Variante ' + v.number + '"' + getVariantFallbackAttr(v.image) + '>' +
          '<div class="vc-num">Variante ' + v.number + '</div>' +
          '<div class="vc-counter">' +
            '<button class="vc-counter-btn" onclick="vcDecrease(' + v.number + ')">−</button>' +
            '<span class="vc-counter-val">' + qty + '</span>' +
            '<button class="vc-counter-btn" onclick="vcIncrease(' + v.number + ')">+</button>' +
          '</div>' +
        '</div>';
      });
      html += '</div>';
    }

    html += '<div class="vc-disclaimer">Motivwünsche werden nach Verfügbarkeit zugeteilt. Eine Garantie auf das gewählte Motiv ist ausgeschlossen.</div>';
    body.innerHTML = html;
    updateSaveBtn();
  }

  /* ---- single select ---- */
  window.vcSelectSingle = function (num) {
    _selected = num;
    renderBody();
  };

  /* ---- multi counters ---- */
  window.vcIncrease = function (num) {
    var total = 0;
    _variants.forEach(function (v) { total += (_counts[v.number] || 0); });
    if (total >= _count) return;
    _counts[num] = (_counts[num] || 0) + 1;
    renderBody();
  };

  window.vcDecrease = function (num) {
    if (!_counts[num] || _counts[num] <= 0) return;
    _counts[num] -= 1;
    renderBody();
  };

  /* ---- save btn state ---- */
  function updateSaveBtn() {
    var btn = document.getElementById('vcSaveBtn');
    if (_count <= 1) {
      btn.disabled = !_selected;
    } else {
      var total = 0;
      _variants.forEach(function (v) { total += (_counts[v.number] || 0); });
      btn.disabled = total !== _count;
    }
  }

  /* ---- save ---- */
  window.saveVariantChoices = function () {
    var orderId = document.getElementById('neworderid').value;
    var btn = document.getElementById('vcSaveBtn');
    btn.disabled = true;
    btn.textContent = 'Speichern...';

    // Build assignment array: [{itemIndex, variantNumber}]
    var assignments = [];
    if (_count <= 1) {
      assignments.push({ itemIndex: 0, variantNumber: _selected });
    } else {
      var idx = 0;
      _variants.forEach(function (v) {
        var qty = _counts[v.number] || 0;
        for (var i = 0; i < qty; i++) {
          assignments.push({ itemIndex: idx, variantNumber: v.number });
          idx++;
        }
      });
    }

    // Save all assignments in one bulk API call
    $.ajax({
      url: API_BASE + '/api/save-variant-choice-bulk',
      type: 'POST',
      dataType: 'json',
      data: {
        orderId: orderId,
        productId: _productId,
        f_lable: _label,
        assignments: assignments
      },
      success: function () {
        // All saved — update button to read-only state
        if (_btnEl) {
          if (_count <= 1) {
            _btnEl.textContent = 'Variante ' + _selected + ' ✓';
          } else {
            var summary = [];
            _variants.forEach(function (v) {
              var q = _counts[v.number] || 0;
              if (q > 0) summary.push(q + 'x V' + v.number);
            });
            _btnEl.textContent = summary.join(', ') + ' ✓';
          }
          _btnEl.classList.add('chosen');
          // Store chosen data and switch to read-only viewer
          var chosenList = [];
          assignments.forEach(function(a) {
            _variants.forEach(function(v) {
              if (v.number === a.variantNumber) {
                chosenList.push({ number: v.number, image: v.image });
              }
            });
          });
          _btnEl.setAttribute('data-chosen-variants', JSON.stringify(chosenList));
          _btnEl.setAttribute('data-chosen-label', _label);
          _btnEl.onclick = function() { viewChosenVariants(this); };
        }
        closeVariantChooser();
        btn.textContent = 'Speichern';
        btn.disabled = false;
      },
      error: function () {
        btn.textContent = 'Speichern';
        btn.disabled = false;
        alert('Fehler beim Speichern. Bitte erneut versuchen.');
      }
    });
  };

  /* ---- read-only view of chosen variants ---- */
  window.viewChosenVariants = function (btnEl) {
    var chosen = JSON.parse(btnEl.getAttribute('data-chosen-variants') || '[]');
    if (!chosen.length) return;

    var overlay = document.getElementById('vcOverlay');
    var title = document.getElementById('vcTitle');
    title.textContent = 'Gewählte Varianten';

    // Group by variant number: { number: { count, image } }
    var grouped = {};
    chosen.forEach(function (v) {
      if (grouped[v.number]) {
        grouped[v.number].count++;
      } else {
        grouped[v.number] = { count: 1, image: v.image, number: v.number };
      }
    });

    var body = document.getElementById('vcBody');
    var html = '<div class="vc-grid">';
    Object.keys(grouped).forEach(function (num) {
      var g = grouped[num];
      var imgUrl = getVariantImageUrl(g.image);
      var label = g.count > 1 ? g.count + 'x Variante ' + g.number : 'Variante ' + g.number;
      html += '<div class="vc-card vc-card-readonly">' +
        '<img src="' + imgUrl + '" alt="Variante ' + g.number + '"' + getVariantFallbackAttr(g.image) + '>' +
        '<div class="vc-num">' + label + '</div>' +
      '</div>';
    });
    html += '</div>';
    body.innerHTML = html;

    // Hide save/cancel, show only close
    document.getElementById('vcSaveBtn').style.display = 'none';
    document.querySelector('.vc-cancel-btn').textContent = 'Schließen';
    document.querySelector('.vc-cancel-btn').onclick = function () {
      closeVariantChooser();
      // Restore for next use
      document.getElementById('vcSaveBtn').style.display = '';
      document.querySelector('.vc-cancel-btn').textContent = 'Abbrechen';
      document.querySelector('.vc-cancel-btn').onclick = closeVariantChooser;
    };

    overlay.classList.add('active');
  };

  /* ---- preload all variant images into browser cache ---- */
  window.preloadVariantImages = function () {
    var data = window._vcVariantsData;
    if (!data) return;
    Object.keys(data).forEach(function (key) {
      var variants = data[key];
      if (!Array.isArray(variants)) return;
      variants.forEach(function (v) {
        if (v.image && !_preloaded[v.image]) {
          var img = new Image();
          if (!/^https?:\/\//i.test(v.image)) {
            img.onerror = function () {
              this.onerror = null;
              this.src = API_BASE + '/storage/app/public/lottery_first/' + v.image;
            };
          }
          img.src = getVariantImageUrl(v.image);
          _preloaded[v.image] = true;
        }
      });
    });
  };

})();
